import { render, staticRenderFns } from "./PermohonanSwasta.vue?vue&type=template&id=dde4b52a&"
import script from "./PermohonanSwasta.vue?vue&type=script&lang=js&"
export * from "./PermohonanSwasta.vue?vue&type=script&lang=js&"
import style0 from "./PermohonanSwasta.vue?vue&type=style&index=0&id=dde4b52a&prod&lang=css&"
import style1 from "./Elements.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports